export interface IPasswordValidation {
  uppercase: boolean;
  number: boolean;
  length: boolean;
  spaces: boolean;
}

export const passwordValidation = (text?: string): IPasswordValidation => {
  const hasSpaces = text?.includes(' ');

  return {
    uppercase: text ? !!/^(?=.*[A-Z]).*$/.exec(text) : false,
    number: text ? !!/^(?=.*\d).*$/.exec(text) : false,
    length: text ? text?.length >= 8 && text?.length < 31 : false,
    spaces: !hasSpaces,
  };
};
